import React from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { useSelector } from 'react-redux';
import moment from 'moment';

interface ErrorData {
  timestamp: string;
  status: number;
  error: string;
  cause: string;
  message: string;
  path: string;
}

const ErrorDisplay = () => {
  const serverErrorDetails = useSelector(
    (state: { ui: { serverErrorDetails: { data: ErrorData } } }) =>
      state.ui?.serverErrorDetails
  );
  const { timestamp, status, error, cause, message, path } =
    serverErrorDetails?.data || {};

  if (!serverErrorDetails) {
    return null;
  } else {
    return (
      <Card className='error-card'>
        <CardHeader className='error-header'>
          <h5>
            Error {status}: {error}
          </h5>
        </CardHeader>
        <CardBody>
          <p>
            <strong>Cause:</strong> {cause || message || 'No cause available'}
          </p>
          <p>
            <strong>Path:</strong> {path}
          </p>
          <p>
            <strong>Timestamp:</strong>{' '}
            {moment(timestamp).format('DD-MM-YYYY  HH:mm:ss')}
          </p>
        </CardBody>
      </Card>
    );
  }
};

export default ErrorDisplay;
